import React from 'react'

import TrexTarjeta from '../../images/t-rex/t-rex-tarjeta-memorama.svg'

const CardMemorama = () => {
  return(
    <figure>
      <img src={ TrexTarjeta } />
    </figure>
  )
}

export default CardMemorama